import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { DEFAULT_IMAGES, resolveImg } from "../lib/siteImages";

const Ctx = createContext(null);
export const useSiteImages = () => useContext(Ctx);

export function SiteImagesProvider({ children }) {
  const [map, setMap] = useState(DEFAULT_IMAGES);
  const refresh = () => api.get("/site-images").then((r) => setMap({ ...DEFAULT_IMAGES, ...r.data })).catch(() => {});
  useEffect(() => { refresh(); }, []);
  const img = (slot) => resolveImg(map[slot] || DEFAULT_IMAGES[slot]);
  return <Ctx.Provider value={{ img, map, refresh }}>{children}</Ctx.Provider>;
}
